<template>
    <div v-if="data" class="container"> <!--- <code> {{data}} </code> --->
        <div class="row">
            <div class="col-md-3 col-sm-12 contenedor-fecha">
                <div class="raya"></div>
                <h4 class="text-muted Shoulders600-text fecha"> {{fechaString(data.fecha_articulo)}} </h4>
            </div>
            <div class="col-md-9 col-sm-12">
                <h1 class="Crimson400-text titular">
                    {{data.titulo.toUpperCase()}} <!----idarticulo: {{data.idarticulo}}---> 
                </h1>
            </div>
        </div>
        <hr>
        <div> <!--<code> {{data}} </code>-->
            <div> 
                <p class="texto-articulo text-container text-justify my-4">
                    {{data.resumen}}
                </p>

                <div class="text-center">
                    <div v-if="data.recursos.length >1">
                        <div id="carouselExampleControls" class="carousel slide" data-ride="carousel">
                            <div class="carousel-inner">
                                <div>
                                    <div v-for="(recurso,j) in data.recursos" :key="j"  class="carousel-item" :class="{'active': j==0}" data-interval="4000">
                                        <img :src="recurso.url_recurso" class="d-block w-100 h-10">
                                    </div>
                                </div>
                            </div>
                            <a class="carousel-control-prev" href="#carouselExampleControls" role="button" data-slide="prev">
                                <span class="carousel-control-prev-icon" aria-hidden="true"></span>
                                <span class="sr-only">Previous</span>
                            </a>
                            <a class="carousel-control-next" href="#carouselExampleControls" role="button" data-slide="next">
                                <span class="carousel-control-next-icon" aria-hidden="true"></span>
                                <span class="sr-only">Next</span>
                            </a>        
                        </div>
                    </div>
                            
                    <!--  -->
                    <span v-else-if="data.recursos.length == 1">
                        <img v-if="data.recursos[0].url_recurso" style="width:98%" :src="data.url_portada">
                    </span>

                    <img v-else style="width:98%" src="@/assets/imagenes/sin_imagen.png">
                </div>
                
                <div v-html="data.contenido" class="texto-articulo text-container my-4"></div>
                 
            </div>
        </div>
        <div v-if="data.vinculos.length>0" class="my-2 redes-iconos d-flex" style="/*float:right;*/">
            <!-- <p class="h4 text-muted">Redes</p>
            <hr> -->
            <ul v-for="(vinculo, i) in data.vinculos" :key="i" class="list-inline text-center text-md-right mb-0 d-flex justify-content-evenly">
                <li v-show="vinculo.desc_red=='Facebook'" class="rounded-circle mx-1"> <a target="_blank" :href="vinculo.url_red"><i class="fab fa-facebook-square h2"></i></a> </li>    
                <li v-show="vinculo.desc_red=='Instagram'" class="rounded-circle mx-1"> <a target="_blank" :href="vinculo.url_red"><i class="fab fa-instagram-square h2"></i></a> </li>  
                <li v-show="vinculo.desc_red=='Twitter'" class="rounded-circle mx-1"> <a target="_blank" :href="vinculo.url_red"><i class="fab fa-twitter-square h2"></i></a> </li>  
            </ul>
            <!-- {{data.vinculos}} -->
        </div>
    </div>    
</template>

<script>
$('#myModal').on('shown.bs.modal', function () {
  $('#myInput').trigger('focus')
})

import { mapState } from "vuex";
import { mapMutations } from 'vuex'
import axios from "axios"
export default {
    data: function(){
        return {
            data: '',
            url: this.$urlServidor+'SalaDePrensa/api/api/Sala/', 
            id_url: this.$route.params.id,
        }
    },
    computed:{ 
        ...mapState(['post', 'articulo_actual', 'articulo_actual_titulo'])
    },
    methods:{                               
        ...mapMutations(['clasificacion', 'anio', 'mes_anio', 'inicializar_v_detalle', 'clasificacion', 'articulo']),



        //  TRAE EL ARTICULO, ARMA LA VARIABLE ID, QUE SE LLENA:
        // SI VIENE DE LA VARIABLE POST DEL STORE, O DE LA URL
        // SINO, TOMA EL ULTIMO ARTICULO QUE FUE AÑADIDO.
        servicioPrensa(n){

             var id =  this.post? this.post : this.id_url;
                 id =  id? id : this.articulo_actual;     

            var ruta  = this.url+`Item/${id}?_idarticulo=${id}`;

            axios.get(ruta)     
            .then(response => {
                this.data = response.data;
            })
            .catch(function (error) {
                console.log(error);
            });

        },



        /* RECIBE FECHA Y LA CONVIERTE EN CADENA, 03/02/2021 => 03 DE FEBRERO DEL 2021 */
        fechaString(fecha){
            var dia = fecha.substring(0,2);
            var mes = fecha.substring(3,5);
            var anio = fecha.substring(6,10);

            var mesCadena = this.string_mes(mes);
            var fecha_procesada = dia + ' DE ' + mesCadena.toUpperCase() + ' DEL ' + anio;
            return fecha_procesada;
        },



        string_mes(mes){
            if(mes==1) return 'Enero'; if(mes==2) return 'Febrero'; if(mes==3) return 'Marzo'; if(mes==4) return 'Abril';
            if(mes==5) return 'Mayo'; if(mes==6) return 'Junio'; if(mes==7) return 'Julio'; if(mes==8) return 'Agosto';
            if(mes==9) return 'Septiembre'; if(mes==10) return 'Octubre'; if(mes==11) return 'Noviembre'; if(mes==12) return 'Diciembre';
        },

        /** entra una cadena, ejm: 'titular de prensa', reemplaza espaciados
        * @returns 'titular-de-prensa'
        */
        titularURL(titulo){
            let tituloNuevo = titulo;
            let huboEspacio = true;

            while(huboEspacio){
                if(tituloNuevo.indexOf(' ') > 0){
                    tituloNuevo = tituloNuevo.replace(' ', '-');
                }
                else huboEspacio = false;
            }
            return tituloNuevo;

        },

        // SI VERIFICACION DE RUTA. SI ESTA EN VISTA DETALLE, CAMBIA LE AÑADE EL ARTICULO QUE ESTA VISITANDO
        validar_ruta(){
            if(window.location.pathname == '/prensa/vista-detalle' || window.location.pathname == '/prensa/vista-detalle/'){
                let titular = this.titularURL(this.articulo_actual_titulo);
                this.$router.push(`/prensa/vista-detalle/${this.articulo_actual}/${titular}`);
            }
        },
    

    },
    mounted(){
        window.scrollTo(0, 0);
        //LIMPIO LA VARIABLE POST DEL STORE. PARA
        //QUE LA SIGUENTE CONSULTA SEA NUEVA.
        this.articulo(0);  
    },
    created(){
        this.validar_ruta();
        this.servicioPrensa();
        this.inicializar_v_detalle();
        //LIMPIO CLASIFICACION (tipo)
        this.clasificacion(3);
        
    },
    watch:{
        //SI POST CAMBIA, LLAMA A LA FUNCION SERVICIOPRENSA()
        //PARA ACTUALIZAR EL POST     
        post: function(){
            this.servicioPrensa();
        }
    }
}
</script>

<style scope>
    .fa-facebook-square{color: #3b5998;}
    .fa-facebook-square:hover{color: #263e70;}
    .fa-instagram-square{ color: #c13584;}
    .fa-instagram-square:hover{ color: #833ab4;}
    .fa-twitter-square{color: #00acee;}
    .fa-twitter-square:hover{color: #027eae;}

    .container{max-width: 1240px !important;}
    .container hr{ border: .5px solid #eee !important;}
    .texto-articulo{font-size: 1.4rem !important; line-height: 2.5rem; text-align: justify;}
    .text-container{color: #44474a;}

    .raya{
        border-bottom: .2rem solid #999 !important;
        padding: 1rem;
        }
    .fecha{
        font-size: 2rem;
        text-align: right; 
    }
    .titular{
        color: #3e3e3e;
        font-size: 2rem;
        padding-top: 1.5rem;
    }

    blockquote{
    padding: 1.5rem;
    background: #f8f8f8;
    border-left: 5px solid #cbcbcb;
    }
    

    @media only screen and (max-device-width : 900px) {
        .contenedor-fecha{ padding: 0 .2rem;}
        .titular { font-size: 1.6rem; }
        .fecha{
            font-size: 1.3rem;
            text-align: end;
            margin-left: .7rem;
            margin-top: .7rem;
        }
    }

    @media only screen and (max-device-width : 420px) {
        .raya{ display: none; }
        .fecha{
            font-size: 1.2rem;
            text-align: start;
        }
        .titular{
            padding-top: 0;
            font-size: 1.5rem;
        }

        .texto-articulo {
            font-size: 1rem !important;
            text-align: left;
            line-height: 1.8rem;
        }
       
        hr{ display: none; }
       
    }

</style>